export default [
  {
    type: 'input',
    placeholder: '版本名称',
    filed: 'name',
    default: ''
  },
  {
    type: 'input',
    placeholder: '版本号',
    filed: 'code',
    default: ''
  },
  {
    type: 'select',
    placeholder: 'APP类型',
    filed: 'type',
    default: '',
    options: [
      {
        code: '01',
        name: '厨房冷柜'
      },
      {
        code: '02',
        name: '红酒柜'
      }
    ]
  }
]
